import { useDeleteCompanySite as useDeleteCompanySiteMutation } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'COMPANY_SITES.TABLE.ACTIONS';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_COMPANY_SITE';

type UseDeleteCompanySiteReturnType = {
  handleDeleteCompanySite: (siteId: string) => void;
};

export const useDeleteCompanySite = (
  companyId: string
): UseDeleteCompanySiteReturnType => {
  const { t } = useTranslation('companyDetailsGeneral');
  const { showSuccess, showError } = useNotification();
  const { mutate: mutateDelete } = useDeleteCompanySiteMutation();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const onConfirm = (siteId: string): void => {
    mutateDelete(
      { companyId, siteId },
      { onSuccess, onError }
    );
  };

  const handleDeleteCompanySite = (siteId: string): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.DELETE_CONFIRMATION_TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.DELETE_CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(siteId),
    });
  };

  return { handleDeleteCompanySite };
};
